import React, { useContext } from "react";
import { VideoContext } from '../../context/VideoContext'
import introVideo from '../../view/Arctic Monkeys.mp4'

import "./video.css";
export function Video(){
  const  {mute, change}  = useContext(VideoContext);
  const handlerEvent = (e) => { e.preventDefault(change());};
  return (
    <div className="container-div-video" style={{ userSelect: 'none', WebkitUserSelect: 'none'}}  >
        <video controls={true} autoPlay={true} onVolumeChangeCapture={handlerEvent}  muted={mute} preload="auto" loop={false} src={ introVideo } type="mp4" />
    </div>
  );
}
